import React from 'react'
import {useHistory} from "react-router-dom"
import Logo from "../image/logo.png"

import { useLocation } from "react-router-dom"


const Header = () => {
  const history = useHistory()
  const token = window.localStorage.getItem('token')
  const sampleLocation = useLocation();
  console.log(sampleLocation.pathname)

  const logout = () => {
      window.localStorage.removeItem('token')
      history.push('/login')
      history.go()
  }
  return (
    <nav className='bg-black  '>
      <div className='w-full  h-24 sm:flex'>
        <div className='w-1/12 '></div>
        <div className='w-2/5 mt-10 md:text-xs hidden  sm:flex  lg:flex text-white  text-base'>
        <a href='/' className='text-gray-100 text-sm ml-2 hover:underline   h-8 w-20  py-1 rounded'>AUTO</a>
         <a href='/' className='text-gray-100 text-sm ml-2 hover:underline   h-8 w-20  py-1 rounded'>RACING</a>
            <a href='/' className='text-gray-100 text-sm  ml-2 hover:underline h-8 w-20  py-1 rounded'>STORE</a>
        </div>
        <div className='w-20 hidden sm:flex'>
              <a href='/'>  <img className='w-20 h-20' alt='Logo' src={Logo}/>   </a>
            </div>
        <div className='flex  justify-end pr-4 w-full sm:w-2/5'>
            
          <div className=' justify-end   mt-10 text-white flex '>
            {token ? (
            <div className='justify-end'>
              {sampleLocation.pathname == '/user' ? (<a className='text-gray-100 font-bold sm:font-normal  ml-2 hover:underline h-8 w-20  py-1 rounded' href='/'>Inicio</a>)    :   (<a href='/user' className='text-gray-100 font-bold sm:font-normal  ml-2 hover:underline h-8 w-20  py-1 rounded'>Account</a>)}
              
              <a className='cursor-pointer font-bold sm:font-normal hover:underline ml-2' onClick={logout}>Logout</a>
            </div>
            ) : (
            <div> <a href="/login"><a className='font-bold sm:font-normal ml-6 mt-1'>Iniciar Sesion</a></a>
            <a  href='register'><a className='font-bold sm:font-normal ml-4 mt-1'>Register</a></a></div>
            ) }

        </div>
        </div>
       
        
      </div>
    </nav>
  )
}

export default Header